import * as fromAuth from './auth'
import * as fromArea from './area'
import * as fromEvent from './event'
import * as fromLecture from './lecture'
import * as fromUser from './user'
import * as fromVideo from './video'
import * as fromSharingGroup from './sharing-group'
import * as fromYoutubeCaption from './youtube-caption'
import * as fromStaticContent from './static-content'

export interface AppState {
  auth: fromAuth.State
  videoArea: fromArea.State
  videoEvent: fromEvent.State
  staticContentArea: fromArea.State
  staticContentEvent: fromEvent.State
  lecture: fromLecture.State
  user: fromUser.State
  video: fromVideo.State
  sharingGroup: fromSharingGroup.State
  youtubeCaption: fromYoutubeCaption.State
  staticContent: fromStaticContent.State
}

export const reducers = {
  auth: fromAuth.reducer,
  videoArea: fromArea.videoReducer,
  videoEvent: fromEvent.videoReducer,
  staticContentArea: fromArea.staticContentReducer,
  staticContentEvent: fromEvent.staticContentReducer,
  lecture: fromLecture.reducer,
  user: fromUser.reducer,
  video: fromVideo.reducer,
  sharingGroup: fromSharingGroup.reducer,
  youtubeCaption: fromYoutubeCaption.reducer,
  staticContent: fromStaticContent.reducer,
}



// WEBPACK FOOTER //
// ./src/reducers/index.ts